<template>
  <div :style="style" id="configuration">
    <ext-header :bkgColour="panelBkgColour" :fontColour="panelFontColour" />
    <b-overlay :show="loading" rounded="sm">
      <div v-if="page == 'config'">
        <b-jumbotron>
          <b-container fluid>
            <h1 class="display-3">
              <b>{{ channelName }} Configuration</b>
            </h1>
            <p class="lead">
              Configure the statistic milestones you would like to achieve!
            </p>
            <h4 class="display-10">
              <b>Stat-Milestones Discord</b>
            </h4>
            <div class="lead">
              <li>
                Join the Stat-Milestones Discord community to get help and
                support!
              </li>
            </div>
            <p class="lead">
              <li>
                <a :href="discordLink" target="_blank">{{ discordLink }}</a>
              </li>
            </p>
          </b-container>
        </b-jumbotron>
      </div>
      <div v-else>
        <br />
      </div>

      <b-input-group prepend="Default View:">
        <b-form-select
          v-model="misc.view"
          :options="misc.views"
          :disabled="viewsValidation"
          @change="sendEvent('configuration', 'click', 'default-view')"
        >
          <template #first>
            <b-form-select-option value="" disabled
              >-- Please select an option --</b-form-select-option
            >
          </template>
        </b-form-select>
      </b-input-group>

      <br />
      <div v-if="this.subscribers.enabled">
        <b-input-group prepend="Receive Updates About Stat-Milestones">
          <b-input-group-append style="margin-left: 25px">
            <b-form-radio-group
              v-model="misc.optIn"
              button-variant="outline-success"
              size="sm"
              buttons
            >
              <b-form-radio
                v-for="option in newsletterOpts"
                v-bind:button-variant="option.buttonVariant"
                v-bind:value="option.value"
              >
                {{ option.text }}
              </b-form-radio>
            </b-form-radio-group>
          </b-input-group-append>
        </b-input-group>
      </div>

      <br />
      <div role="tablist" :style="style">
        <b-button
          block
          href="#"
          v-b-toggle.theme-card
          @click="sendEvent('configuration', 'click', 'expand-theme-panel')"
        >
          Theme Settings
        </b-button>

        <b-collapse id="theme-card" accordion="my-accordion" role="tabpanel">
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <b-list-group class="mx-auto text-center">
              <b-list-group-item>
                <b-input-group prepend="Background Colour">
                  <b-input-group-append id="colourPos">
                    <color-picker
                      format="hex"
                      shape="square"
                      v-model:pureColor="panelBkgColour"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Font Colour">
                  <b-input-group-append id="colourPos">
                    <color-picker
                      format="hex"
                      shape="square"
                      v-model:pureColor="panelFontColour"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Dark-Mode">
                  <b-input-group-append style="margin-left: 25px">
                    <b-form-radio-group
                      v-model="darkMode"
                      button-variant="outline-success"
                      size="sm"
                      buttons
                    >
                      <b-form-radio
                        v-for="option in newsletterOpts"
                        v-bind:button-variant="option.buttonVariant"
                        v-bind:value="option.value"
                      >
                        {{ option.text }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-collapse>
        <br />

        <b-button
          block
          href="#"
          v-b-toggle.motd-card
          @click="sendEvent('configuration', 'click', 'expand-motd-panel')"
        >
          Message Of The Day
        </b-button>

        <b-collapse
          id="motd-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="motd-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <b-list-group class="mx-auto text-center">
              <b-list-group-item>
                <b-input-group prepend="MOTD">
                  <b-form-textarea
                    :state="motdTargetState"
                    v-model="motd.msg"
                    ref="motdMsgInput"
                    aria-label="Message Of The Day"
                    aria-describedby="your Message Of The Day"
                    placeholder="Message Of The Day"
                    @click="
                      sendEvent('configuration', 'click', 'motd-msg-input')
                    "
                  ></b-form-textarea>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Duration">
                  <b-form-select v-model="motd.ts" class="mb-3">
                    <option :value="null">Select</option>
                    <option value="10000">10 seconds</option>
                    <option value="15000">15 seconds</option>
                    <option value="30000">30 seconds</option>
                    <option value="60000">1 minute</option>
                  </b-form-select>
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-collapse>

        <br />
        <div>
          <b-button
            block
            href="#"
            id="expand-boasts-btn"
            v-b-toggle.boasts-card
            @click="sendEvent('configuration', 'click', 'expand-boasts-panel')"
          >
            Viewer Boasts
          </b-button>
        </div>

        <b-collapse
          id="boasts-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="boasts-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div>
              <b-list-group class="mx-auto text-center">
                <b-list-group-item>
                  <b-table
                    headerTitle="Boasts by viewers"
                    stripped
                    hover
                    :items="boasts.list"
                    :busy="boasts.busy"
                    :fields="boasts.fields"
                    outlined
                    responsive="sm"
                  >
                    <template #table-busy>
                      <div v-if="boasts.loading" class="text-center">
                        <b-spinner variant="primary" label="Text Centered" />
                      </div>
                      <div v-else class="text-center text-danger my-2">
                        <strong
                          >No viewers have published boasts for
                          Stat-Milestones</strong
                        >
                      </div>
                    </template>

                    <template #cell(delete)="data">
                      <b-button
                        variant="danger"
                        @click="deleteBoast(boasts.list, data)"
                        >X</b-button
                      >
                    </template>
                  </b-table>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </b-collapse>

        <br />
        <b-button
          block
          href="#"
          id="expand-twitch-goal-btn"
          v-b-toggle.goals-card
          @click="
            sendEvent('configuration', 'click', 'expand-twitch-goal-panel')
          "
        >
          Twitch Goal
        </b-button>

        <b-collapse
          id="goals-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="goals-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div v-if="!this.goals.enabled">
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-button
                    href="#"
                    id="expand-goals-btn"
                    v-b-toggle.goals-card
                    v-b-popover.hover.top="
                      'Stat-Milestones requires permission to access your Goals!'
                    "
                    title="*GRANT PERMISSIONS*"
                    @click="
                      sendEvent('configuration', 'click', 'authorize-twitch');
                      authorizePermissions();
                    "
                  >
                    Authorize
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div v-else>
              <div v-if="goals.active">
                <b-list-group class="mx-auto text-center">
                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Type">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ goals.type }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Description">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ goals.description }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Progress">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ goals.count.toLocaleString() }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Target">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ goals.target.toLocaleString() }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-input-group prepend="Gauge Colour">
                      <b-input-group-append id="colourPos">
                        <color-picker
                          format="hex"
                          shape="square"
                          v-model:pureColor="goals.gaugeColour"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>
                </b-list-group>
              </div>
              <div v-else>
                <b-list-group class="mx-auto text-center">
                  <b-list-group-item class="text-center">
                    <b-alert show variant="light">
                      Learn how to configure a Twitch Goal
                      <a
                        href="https://help.twitch.tv/s/article/creator-goals?language=en_US"
                        target="_blank"
                      >
                        here!</a
                      >
                    </b-alert>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-card>
        </b-collapse>

        <br />

        <b-button
          block
          href="#"
          id="expand-twitch-charity-btn"
          v-b-toggle.charity-card
          @click="
            sendEvent('configuration', 'click', 'expand-twitch-charity-panel')
          "
        >
          Twitch Charity - <b-badge variant="light">New Feature!</b-badge>
        </b-button>

        <b-collapse
          id="charity-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="charity-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div v-if="!this.charity.enabled">
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-button
                    href="#"
                    id="expand-charity-btn"
                    v-b-toggle.charity-card
                    v-b-popover.hover.top="
                      'Stat-Milestones requires permission to access your Twitch Charity Config!'
                    "
                    title="*GRANT PERMISSIONS*"
                    @click="
                      sendEvent('configuration', 'click', 'authorize-twitch');
                      authorizePermissions();
                    "
                  >
                    Authorize
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div v-else>
              <div v-if="charity.active">
                <b-list-group class="mx-auto text-center">
                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Name">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ charity.name }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Currency">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ charity.currency }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Progress">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ charity.count.toLocaleString() }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item class="text-center">
                    <b-input-group prepend="Target">
                      <b-input-group-append>
                        <div class="input-group-text">
                          <strong>
                            {{ charity.target.toLocaleString() }}
                          </strong>
                        </div>
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>

                  <b-list-group-item>
                    <b-input-group prepend="Gauge Colour">
                      <b-input-group-append id="colourPos">
                        <color-picker
                          format="hex"
                          shape="square"
                          v-model:pureColor="charity.gaugeColour"
                        />
                      </b-input-group-append>
                    </b-input-group>
                  </b-list-group-item>
                </b-list-group>
              </div>
              <div v-else>
                <b-list-group class="mx-auto text-center">
                  <b-list-group-item class="text-center">
                    <b-alert show variant="light">
                      Setup a Charity Fundraiser on Twitch
                      <a
                        href="https://dashboard.twitch.tv/charity"
                        target="_blank"
                      >
                        Here!</a
                      >
                    </b-alert>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-card>
        </b-collapse>
        <br />

        <div>
          <b-button
            block
            href="#"
            id="expand-channelpoints-btn"
            v-b-toggle.channelpoints-card
            @click="sendEvent('configuration', 'click', 'expand-message-panel')"
          >
            Channel Points
          </b-button>
        </div>

        <b-collapse
          id="channelpoints-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="channelpoints-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div v-if="!this.subscribers.enabled">
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-button
                    href="#"
                    id="expand-channelpoints-btn"
                    v-b-toggle.channelpoints-card
                    v-b-popover.hover.top="
                      'Stat-Milestones requires permission to access your channel points!'
                    "
                    title="*GRANT PERMISSIONS*"
                    @click="
                      sendEvent('configuration', 'click', 'authorize-twitch');
                      authorizePermissions();
                    "
                  >
                    Authorize
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div v-else>
              <b-list-group class="mx-auto text-center">
                <b-list-group-item>
                  <b-input-group
                    prepend="Please make sure you have setup your StreamLabs alerts browser source "
                  ></b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Streamlabs">
                    <div v-if="!this.messages.streamlabs">
                      <b-button
                        variant="danger"
                        href="#"
                        v-b-popover.hover.top="
                          'Allow Stat-Milestones to alert you when a user redeems a channel point reward!'
                        "
                        title="*GRANT PERMISSIONS*"
                        @click="
                          sendEvent(
                            'configuration',
                            'click',
                            'authorize-streamlabs'
                          );
                          authorizeStreamlabs();
                        "
                      >
                        Authorize
                      </b-button>
                    </div>

                    <div v-else>
                      <b-button
                        variant="success"
                        href="#"
                        v-b-popover.hover.top="'Test an alert for streamlabs'"
                        title="*Streamlabs Alert Test*"
                        @click="
                          sendEvent(
                            'configuration',
                            'click',
                            'test-alert-streamlabs'
                          );
                          streamlabsTest();
                        "
                      >
                        Test Alert
                      </b-button>
                    </div>
                  </b-input-group>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </b-collapse>

        <br />

        <b-button
          block
          href="#"
          v-b-toggle.follower-card
          @click="sendEvent('configuration', 'click', 'expand-followers-panel')"
        >
          Followers
        </b-button>

        <b-collapse
          id="follower-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="follower-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <b-list-group class="mx-auto text-center">
              <b-list-group-item class="text-center">
                <b-input-group prepend="Followers">
                  <b-input-group-append>
                    <div class="input-group-text">
                      <strong> {{ followers.toLocaleString() }} </strong>
                    </div>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item class="text-center">
                <b-input-group prepend="Button Events">
                  <b-input-group-append>
                    <div
                      class="input-group-text"
                      v-b-popover.hover.top="
                        'Number of viewers who followed YOU using Stat-Milestones'
                      "
                      title="New Followers!"
                      @mouseover="
                        sendEvent(
                          'configuration',
                          'hover',
                          'follower-button-events-count'
                        )
                      "
                    >
                      <strong> {{ buttonEvents.toLocaleString() }} </strong>
                    </div>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Target">
                  <b-form-input
                    :state="targetState"
                    v-model="target"
                    :formatter="formatNumber"
                    ref="followersCountInput"
                    style="text-align: center"
                    aria-label="desired followers"
                    aria-describedby="your desired amount of followers"
                    placeholder="your desired amount of followers"
                    @click="
                      sendEvent(
                        'configuration',
                        'click',
                        'followers-target-count'
                      )
                    "
                  ></b-form-input>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <div v-if="this.page != 'live-config'">
                  <b-input-group prepend="Message to Followers">
                    <b-form-input
                      style="text-align: center"
                      v-model="message"
                      ref="followersMessageInput"
                      placeholder="Message displayed to followers..."
                      :state="messageState"
                      trim
                      @click="
                        sendEvent(
                          'configuration',
                          'click',
                          'followers-custom-message'
                        )
                      "
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="
                          emojiShow = !emojiShow;
                          sendEvent(
                            'configuration',
                            'click',
                            'followers-display-emojis'
                          );
                        "
                        variant="outline-primary"
                      >
                        <font-awesome-icon
                          icon="smile-wink"
                        ></font-awesome-icon>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-list-group-item>

              <b-list-group-item>
                <div v-if="this.page != 'live-config'">
                  <b-input-group prepend="Display Recent followers">
                    <b-input-group-append style="margin-left: 100px">
                      <b-form-radio-group
                        v-model="displayRecentFollowers"
                        button-variant="outline-success"
                        size="sm"
                        buttons
                      >
                        <b-form-radio
                          v-for="option in newsletterOpts"
                          v-bind:button-variant="option.buttonVariant"
                          v-bind:value="option.value"
                        >
                          {{ option.text }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Gauge Colour">
                  <b-input-group-append id="colourPos">
                    <color-picker
                      format="hex"
                      shape="square"
                      v-model:pureColor="followersGaugeColour"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-collapse>

        <br />
        <b-button
          block
          href="#"
          id="expand-subscribers-btn"
          v-b-toggle.subscribers-card
          @click="
            sendEvent('configuration', 'click', 'expand-subscribers-panel')
          "
        >
          Subscribers
        </b-button>

        <b-collapse
          id="subscribers-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="subscribers-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div v-if="!this.subscribers.enabled">
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-button
                    href="#"
                    id="expand-subscribers-btn"
                    v-b-toggle.subscribers-card
                    v-b-popover.hover.top="
                      'Stat-Milestones requires permission to access your subscribers!'
                    "
                    title="*GRANT PERMISSIONS*"
                    @click="
                      sendEvent('configuration', 'click', 'authorize-twitch');
                      authorizePermissions();
                    "
                  >
                    Authorize
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>

            <div v-else>
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-input-group prepend="Subscribers">
                    <b-input-group-append>
                      <div class="input-group-text">
                        <strong>
                          {{ subscribers.count.toLocaleString() }}
                        </strong>
                      </div>
                    </b-input-group-append>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Target">
                    <b-form-input
                      v-model="subscribers.target"
                      :state="subsTargetState"
                      :formatter="formatNumber"
                      ref="subsTargetRange"
                      style="text-align: center"
                      aria-label="desired subscribers"
                      aria-describedby="your desired amount of subscribers"
                      placeholder="your desired amount of subscribers"
                      @click="
                        sendEvent(
                          'configuration',
                          'click',
                          'subscribers-target-count'
                        )
                      "
                    ></b-form-input>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Gauge Colour">
                    <b-input-group-append id="colourPos">
                      <color-picker
                        format="hex"
                        shape="square"
                        v-model:pureColor="subscribers.gaugeColour"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </b-collapse>

        <br />
        <div @mouseover="bitsSupported()" @mouseout="bitsSupported()">
          <b-button
            block
            href="#"
            id="expand-messages-btn"
            v-b-toggle.messages-card
            :disabled="!bitsEnabled()"
            @click="sendEvent('configuration', 'click', 'expand-message-panel')"
          >
            Messages
          </b-button>
        </div>

        <b-collapse
          id="messages-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="messages-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <b-list-group class="mx-auto text-center">
              <b-list-group-item class="text-center">
                <b-input-group prepend="Messages">
                  <b-input-group-append>
                    <div class="input-group-text">
                      <strong> {{ messages.count.toLocaleString() }} </strong>
                    </div>

                    <b-button
                      variant="danger"
                      href="#"
                      @click="
                        resetMessages();
                        sendEvent(
                          'configuration',
                          'click',
                          'messages-reset-counter-btn'
                        );
                      "
                      :disabled="msgResetDisabled"
                    >
                      Reset Message Counter
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Target">
                  <b-form-input
                    v-model="messages.target"
                    :state="msgTargetState"
                    :formatter="formatNumber"
                    ref="msgTargetRange"
                    style="text-align: center"
                    aria-label="desired messages"
                    aria-describedby="your desired amount of messages"
                    placeholder="your desired amount of messages"
                    @click="
                      sendEvent(
                        'configuration',
                        'click',
                        'messages-target-count'
                      )
                    "
                  ></b-form-input>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Streamlabs">
                  <div v-if="!this.messages.streamlabs">
                    <b-button
                      variant="danger"
                      href="#"
                      v-b-popover.hover.top="
                        'Allow Stat-Milestones to alert you when a user sends a message!'
                      "
                      title="*GRANT PERMISSIONS*"
                      @click="
                        sendEvent(
                          'configuration',
                          'click',
                          'authorize-streamlabs'
                        );
                        authorizeStreamlabs();
                      "
                    >
                      Authorize
                    </b-button>
                  </div>

                  <div v-else>
                    <b-button
                      variant="success"
                      href="#"
                      v-b-popover.hover.top="'Test an alert for streamlabs'"
                      title="*Streamlabs Alert Test*"
                      @click="
                        sendEvent(
                          'configuration',
                          'click',
                          'test-alert-streamlabs'
                        );
                        streamlabsTest();
                      "
                    >
                      Test Alert
                    </b-button>
                  </div>
                </b-input-group>
              </b-list-group-item>

              <b-list-group-item>
                <b-input-group prepend="Gauge Colour">
                  <b-input-group-append id="colourPos">
                    <color-picker
                      format="hex"
                      shape="square"
                      v-model:pureColor="messages.gaugeColour"
                    />
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>
            </b-list-group>
          </b-card>
        </b-collapse>
        <div
          v-show="emojiShow == true"
          v-draggable
          style="z-index: 2; position: fixed; left: 400.918px; top: 45.4297px"
        >
          <b-card align="center" header-tag="header">
            <b-card-header style="cursor: move">
              Select Emoji - Draggable
              <b-button
                @click="emojiShow = !emojiShow"
                class="float-right"
                variant="outline-danger"
              >
                x
              </b-button>
            </b-card-header>
            <b-card-body style="padding: 0px">
              <picker
                :data="emojiIndex"
                @select="addEmoji"
                title="Select An Emoji"
                emoji="point_up"
                :color="panelBkgColour"
              />
            </b-card-body>
          </b-card>
        </div>

        <br />
        <div @mouseover="hypetrainSupported()" @mouseout="hypetrainSupported()">
          <b-button
            block
            href="#"
            id="expand-hypetrain-btn"
            v-b-toggle.hypetrain-card
            :disabled="!this.hypetrain.feature"
            @click="
              sendEvent('configuration', 'click', 'expand-hypetrain-panel')
            "
          >
            Hype Train
          </b-button>
        </div>
        <b-collapse
          id="hypetrain-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="hypetrain-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <div v-if="!this.hypetrain.enabled">
              <b-list-group class="mx-auto text-center">
                <b-list-group-item class="text-center">
                  <b-button
                    href="#"
                    id="authorize-hypetrain-btn"
                    v-b-toggle.hypetrain-card
                    v-b-popover.hover.top="
                      'Stat-Milestones requires permission to access your hype trains!'
                    "
                    title="*GRANT PERMISSIONS*"
                    @click="
                      sendEvent('configuration', 'click', 'authorize-twitch');
                      authorizePermissions();
                    "
                  >
                    Authorize
                  </b-button>
                </b-list-group-item>
              </b-list-group>
            </div>
            <div v-else>
              <b-list-group class="mx-auto text-center">
                <b-list-group-item>
                  <b-input-group prepend="Gauge Colour">
                    <b-input-group-append id="colourPos">
                      <color-picker
                        format="hex"
                        shape="square"
                        v-model:pureColor="hypetrain.gaugeColour"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-list-group-item>
              </b-list-group>
            </div>
          </b-card>
        </b-collapse>

        <br />
        <b-button
          block
          href="#"
          v-b-toggle.custom-card
          @click="sendEvent('configuration', 'click', 'expand-custom-panel')"
        >
          Custom
        </b-button>

        <b-collapse
          id="custom-card"
          accordion="my-accordion"
          role="tabpanel"
          ref="custom-card"
        >
          <b-card class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
            </b-card-header>

            <b-list-group class="mx-auto text-center">
              <b-list-group-item>
                <b-input-group prepend="Enable">
                  <b-input-group-append style="margin-left: 25px">
                    <b-form-radio-group
                      v-model="custom.enabled"
                      button-variant="outline-success"
                      size="sm"
                      buttons
                    >
                      <b-form-radio
                        v-for="option in newsletterOpts"
                        v-bind:button-variant="option.buttonVariant"
                        v-bind:value="option.value"
                      >
                        {{ option.text }}
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>

              <div v-if="custom.enabled">
                <b-list-group-item>
                  <b-input-group prepend="Title">
                    <b-form-input
                      :state="customTitleState"
                      v-model="custom.title"
                      ref="customTitleInput"
                      style="text-align: center"
                      aria-label="title"
                      aria-describedby="The title of your statistic"
                      placeholder="The title of your statistic"
                      @click="
                        sendEvent('configuration', 'click', 'custom-title')
                      "
                    ></b-form-input>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Progress">
                    <b-form-input
                      v-model="custom.count"
                      :formatter="formatNumber"
                      ref="customCountInput"
                      style="text-align: center"
                      aria-label="progress"
                      aria-describedby="your current progress"
                      placeholder="your current progress"
                      @click="
                        sendEvent('configuration', 'click', 'custom-progress')
                      "
                    ></b-form-input>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Target">
                    <b-form-input
                      v-model="custom.target"
                      :formatter="formatNumber"
                      ref="customTargetInput"
                      style="text-align: center"
                      aria-label="target"
                      aria-describedby="your desired target"
                      placeholder="your desired target"
                      @click="
                        sendEvent('configuration', 'click', 'custom-target')
                      "
                    ></b-form-input>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Gauge Colour">
                    <b-input-group-append id="colourPos">
                      <color-picker
                        format="hex"
                        shape="square"
                        v-model:pureColor="custom.gaugeColour"
                      />
                    </b-input-group-append>
                  </b-input-group>
                </b-list-group-item>

                <b-list-group-item>
                  <b-input-group prepend="Subscriber Button">
                    <b-input-group-append style="margin-left: 25px">
                      <b-form-radio-group
                        v-model="custom.subButtonEnabled"
                        button-variant="outline-success"
                        size="sm"
                        buttons
                      >
                        <b-form-radio
                          v-for="option in newsletterOpts"
                          v-bind:button-variant="option.buttonVariant"
                          v-bind:value="option.value"
                        >
                          {{ option.text }}
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-input-group-append>
                  </b-input-group>
                </b-list-group-item>
              </div>
            </b-list-group>
          </b-card>
        </b-collapse>

        <br />

        <b-popover
          placement="top"
          blur
          triggers=""
          :show="messages.feature"
          target="expand-messages-btn"
          title="Feature not supported"
        >
          <strong>Your channel does not support bits!</strong>
        </b-popover>

        <b-popover
          placement="top"
          blur
          triggers=""
          v-model:show="hypetrain.popover"
          target="expand-hypetrain-btn"
          title="Feature not supported"
        >
          <strong>Your channel is not affiliate / partner!</strong>
        </b-popover>
      </div>
    </b-overlay>

    <b-container class="text-center">
      <b-container>
        <div v-if="loading == false && error == true">
          <b-alert
            variant="danger"
            show
            dismissible
            fade
            @dismissed="
              error = false;
              errorMsg = '';
              sendEvent('configuration', 'click', 'error-dismiss');
            "
          >
            {{ errorMsg }}
          </b-alert>
        </div>
        <div v-else-if="loading == false && success == true">
          <b-alert
            variant="success"
            show
            dismissible
            fade
            @dismissed="sendEvent('configuration', 'click', 'success-dismiss')"
          >
            {{ successMsg }}
          </b-alert>
        </div>
      </b-container>
      <br />
      <b-container>
        <b-button
          variant="success"
          :disabled="loading"
          @click="
            saveConfig();
            sendEvent('configuration', 'click', 'configuration-save');
          "
        >
          save
        </b-button>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import ExtHeader from "@/components/ExtHeader.vue";
import FollowersAPI from "@/api/followers.js";
import BitsAPI from "@/api/bits.js";
import DiscordAPI from "@/api/discord.js";
import MessagesAPI from "@/api/messages.js";
import StreamlabsAPI from "@/api/streamlabs.js";
import SubscribersAPI from "@/api/subscribers.js";
import GoalsAPI from "@/api/goals.js";
import CharityAPI from "@/api/charity.js";
import HypeTrainAPI from "@/api/hypetrain.js";
import ConfigAPI from "@/api/config.js";
import BoastsAPI from "@/api/boasts.js";

import emojiData from "emoji-mart-vue-fast/data/all.json";
// Import default CSS
import "emoji-mart-vue-fast/css/emoji-mart.css";

// Create emoji data index.
// We can change it (for example, filter by category) before passing to the component.
import { Picker, EmojiIndex } from "emoji-mart-vue-fast/src";
let emojiIndex = new EmojiIndex(emojiData);

import { SET_RELEASE_STATE } from "@/store/mutations";

// Import the styles too, globally

import { ColorPicker } from "vue3-colorpicker";
import "vue3-colorpicker/style.css";

export default {
  name: "configuration",
  data() {
    return {
      discordLink: "",

      misc: {
        view: "followers",
        views: [{ value: "followers", text: "Followers" }],
        optIn: false,
      },

      motd: {
        msg: "",
        ts: 0,
      },

      emojiIndex: emojiIndex,
      // panel
      panelBkgColour: "#222F3D",
      panelFontColour: "#DDE6E8",
      darkMode: false,
      appBkgColour: "white",
      appFontColour: "black",

      // followers
      followers: 0,
      boasts: {
        list: [],
        overlay: true,
        busy: true,
        loading: true,
        fields: [
          {
            key: "username",
            sortable: true,
          },
          {
            key: "message",
          },
          {
            key: "human_ttl",
            label: "Expires",
            sortable: true,
          },
          {
            key: "delete",
          },
        ],
      },

      buttonEvents: 0,
      target: "50",
      followersGaugeColour: "#5583c7",
      message: "🔥🎉  Thank you !  🎉🔥",
      displayRecentFollowers: true,
      followersCardVisible: false,
      msgCardVisible: false,
      subsCardVisible: false,
      motdCardVisible: false,
      customCardVisible: false,
      goalsCardVisible: false,
      charityCardVisible: false,

      // messages
      messages: {
        count: 0,
        feature: false,
        target: "10",
        gaugeColour: "#5583c7",
        enabled: false,
        streamlabs: false,
      },

      custom: {
        count: "0",
        target: "0",
        gaugeColour: "#5583c7",
        enabled: false,
        img: "",
        title: "",
        subButtonEnabled: false,
      },

      subscribers: {
        count: 0,
        users: [],
        target: "10",
        gaugeColour: "#5583c7",
        enabled: false,
      },

      newsletterOpts: [
        { text: "Enabled", value: true, buttonVariant: "outline-success" },
        { text: "Disabled", value: false, buttonVariant: "outline-danger" },
      ],

      hypetrain: {
        count: 0,
        target: 0,
        level: 0,
        gaugeColour: "#5583c7",
        popover: false,
        feature: true,
        enabled: false,
      },

      goals: {
        enabled: false,
        active: false,
        count: 0,
        target: 0,
        gaugeColour: "#5583c7",
        description: "",
        type: "",
      },

      charity: {
        enabled: false,
        active: false,
        currency: "",
        count: 0,
        target: 0,
        gaugeColour: "#5583c7",
        description: "",
        name: "",
      },

      polls: {
        enabled: false,
        feature: true,
        popover: false,
        dropdown: [],
        segments: [],
        id: "",
      },

      apiPolls: [],
      apiPredictions: [],

      predictions: {
        enabled: false,
        feature: true,
        segments: [],
        dropdown: [],
        id: "",
      },

      //misc
      channelName: "User",
      emojiShow: false,

      toggleHeight: 40,
      toggleWidth: 300,

      toggleCustomWidth: 350,
      toggleCustomHeight: 40,
      // api handling
      error: false,
      errorMsg: "",
      successMsg: "Configuration updated!",
      success: false,
      loading: false,
    };
  },
  props: {
    page: String,
  },
  mounted() {
    ga("set", "page", "/" + this.page);
    ga("send", "pageview");

    this.getGoals();
    this.getCharities();
    this.getFollowers();
    this.getSubscribers();
    this.getHypeTrain();
    this.getBoasts();
    this.getDiscordWidget();
    this.streamlabsAuth();
    if (this.bitsEnabled()) {
      this.messages.enabled = true;
      this.getMessages();
      this.misc.views.push({ value: "messages", text: "Messages" });
    } else {
      this.messages.enabled = false;
    }

    this.channelName = ConfigAPI.getUsername();
    this.setBoadcasterConfiguration();

    if (this.custom.enabled) {
      var item = {
        value: "custom",
        text: this.custom.title,
      };
      this.misc.views.push(item);
    }

    this.$root.$on("bv::collapse::state", this.cardVisibility);
    this.eventBus.$on("user-granted-auth", this.accessGranted);
    this.eventBus.$on("user-granted-streamlabs-auth", this.streamlabsAuth);
  },
  methods: {
    setBoadcasterConfiguration: function () {
      var config = ConfigAPI.getBroadcasterConfig();

      if (config.misc) {
        var misc = config.misc;
        if (misc.view) {
          this.misc.view = misc.view;
        }
        if (misc.optIn) {
          this.misc.optIn = misc.optIn;
        }
      }

      if (config.panel_settings) {
        var panel = config.panel_settings;
        if (panel.background_colour) {
          this.panelBkgColour = panel.background_colour;
        }
        if (panel.font_colour) {
          this.panelFontColour = panel.font_colour;
        }
        if (panel.dark_mode) {
          this.darkMode = panel.dark_mode;
        }
      }

      if (config.followers) {
        var followers = config.followers;

        if (followers.gauge_colour) {
          this.followersGaugeColour = followers.gauge_colour;
        }
        if (followers.message) {
          this.message = followers.message;
        }
        if (followers.target && followers.target != 0) {
          this.target = parseInt(followers.target).toLocaleString();
        }
        if (followers.display_recent_followers) {
          this.displayRecentFollowers = followers.display_recent_followers;
        }
      }

      if (config.messages) {
        var messages = config.messages;

        if (messages.gauge_colour) {
          this.messages.gaugeColour = messages.gauge_colour;
        }
        if (messages.target && messages.target != 0) {
          this.messages.target = parseInt(messages.target).toLocaleString();
        }
      }

      if (config.hypetrain) {
        var hypetrain = config.hypetrain;

        if (hypetrain.gauge_colour) {
          this.hypetrain.gaugeColour = hypetrain.gauge_colour;
        }
      }

      if (config.subscribers) {
        var subs = config.subscribers;
        if (subs.gauge_colour) {
          this.subscribers.gaugeColour = subs.gauge_colour;
        }
        if (subs.target && subs.target != 0) {
          this.subscribers.target = parseInt(subs.target).toLocaleString();
        }
      }

      if (config.goals) {
        var goals = config.goals;
        if (goals.gauge_colour) {
          this.goals.gaugeColour = goals.gauge_colour;
        }
      }

      if (config.charity) {
        var charity = config.charity;
        if (charity.gauge_colour) {
          this.charity.gaugeColour = charity.gauge_colour;
        }
      }

      if (config.custom) {
        var custom = config.custom;

        if (custom.title) {
          this.custom.title = custom.title;
        }
        if (custom.enabled) {
          this.custom.enabled = custom.enabled;
        }
        if (custom.gaugeColour) {
          this.custom.gaugeColour = custom.gaugeColour;
        }
        if (custom.count) {
          this.custom.count = parseInt(custom.count).toLocaleString();
        }
        if (custom.target) {
          this.custom.target = parseInt(custom.target).toLocaleString();
        }
        if (custom.img) {
          this.custom.img = custom.img;
        }
        if (custom.subButtonEnabled) {
          this.custom.subButtonEnabled = custom.subButtonEnabled;
        }
      }

      if (config.motd) {
        this.motd = config.motd;
      }
    },
    getFollowers: function () {
      FollowersAPI.getFollowers()
        .then((resp) => {
          this.followers = resp.data.followers;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your followers configuration, PLEASE REFRESH!";
          this.error = true;
          this.sendEvent("api", "failure", "get-followers-for-config");
        });

      FollowersAPI.getFollowerButtonEvents().then((resp) => {
        this.buttonEvents = resp.data.count;
      });
    },
    getSubscribers: function () {
      SubscribersAPI.getSubscribers()
        .then((resp) => {
          if (resp.data.error) {
            if (resp.data.error == "Missing user access token") {
              this.subscribers.enabled = false;
              return;
            }

            this.errorMsg = "Oops! Subcribers " + resp.data.error;
            this.error = true;
            this.subscribers.enabled = false;
            this.sendEvent("api", "failure", "subscribers-auth-failure");

            return;
          }

          this.subscribers.enabled = true;
          if (resp.data.count) {
            this.subscribers.count = resp.data.count;
          }
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your subscribers configuration, PLEASE REFRESH!";
          this.error = true;
          this.subscribers.enabled = false;
          this.sendEvent("api", "failure", "get-subscribers-for-config");
        });
    },
    getGoals: function () {
      GoalsAPI.getGoals()
        .then((resp) => {
          if (resp.data.error) {
            if (
              resp.data.error == "Missing user access token" ||
              resp.data.error == "Missing Valid Scope"
            ) {
              this.goals.enabled = false;
              return;
            }

            this.errorMsg = "Oops! Goals " + resp.data.error;
            this.error = true;
            this.goals.enabled = false;
            this.sendEvent("api", "failure", "goals-auth-failure");

            return;
          }

          if (resp.data.count > 0) {
            var goal = resp.data.goal;
            this.goals.count = goal.current_amount;
            this.goals.target = goal.target_amount;
            this.goals.description = goal.description;
            this.goals.type = goal.type;
            this.goals.active = true;
          }
          this.goals.enabled = true;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your goals configuration, PLEASE REFRESH!";
          this.error = true;
          this.subscribers.enabled = false;
          this.sendEvent("api", "failure", "get-goals-for-config");
        });
    },
    getCharities: function () {
      CharityAPI.getCharities()
        .then((resp) => {
          if (resp.data.error) {
            if (
              resp.data.error == "Missing user access token" ||
              resp.data.error == "Missing Valid Scope"
            ) {
              this.charity.enabled = false;
              return;
            }

            this.errorMsg = "Oops! Charity API " + resp.data.error;
            this.error = true;
            this.charity.enabled = false;
            this.sendEvent("api", "failure", "charity-auth-failure");

            return;
          }

          if (resp.data.count > 0) {
            var charity = resp.data.charity_campaign;
            this.charity.count = charity.current_amount.amount;
            this.charity.target = charity.target_amount.amount;
            this.charity.currency = charity.target_amount.currency;
            this.charity.name = charity.charity_name;
            this.charity.active = true;
          }
          this.charity.enabled = true;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your charity configuration, PLEASE REFRESH!";
          this.error = true;
          this.subscribers.enabled = false;
          this.sendEvent("api", "failure", "get-charity-for-config");
        });
    },
    getHypeTrain: function () {
      HypeTrainAPI.getHypeTrain()
        .then((resp) => {
          if (resp.data.error) {
            switch (resp.data.error) {
              case ("Missing scope", "Missing user access token"):
                this.hypetrain.enabled = false;
                this.hypetrain.feature = true;

                return;
              case "Invalid broadcaster type":
                this.hypetrain.enabled = false;
                this.hypetrain.feature = false;
                return;
            }

            this.errorMsg = "Oops! HypeTrain " + resp.data.error;
            this.error = true;
            this.hypetrain.enabled = false;
            this.sendEvent("api", "failure", "hypetrain-auth-failure");

            return;
          }

          this.misc.views.push({ value: "hypetrain", text: "Hype Train" });
          this.hypetrain.enabled = true;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your Hype Train configuration, PLEASE REFRESH!";
          this.error = true;
          this.hypetrain.enabled = false;
          this.sendEvent("api", "failure", "get-hypetrain-for-config");
        });
    },
    getPolls: function () {
      PollsAPI.getPolls()
        .then((resp) => {
          if (resp.data.error) {
            switch (resp.data.error) {
              case ("Missing scope", "Missing user access token"):
                this.polls.enabled = false;
                this.polls.feature = true;

                return;
              case "Invalid broadcaster type":
                this.polls.enabled = false;
                this.polls.feature = false;
                return;
            }

            this.errorMsg = "Oops! Polls " + resp.data.error;
            this.error = true;
            this.polls.enabled = false;
            this.sendEvent("api", "failure", "polls-auth-failure");

            return;
          }

          for (i = 0; i < resp.data.polls.length; i++) {
            var poll = resp.data.polls[i];

            this.polls.dropdown.push({ value: poll.id, text: poll.title });
          }

          this.polls.enabled = true;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your Polls, PLEASE REFRESH!";
          this.error = true;
          this.polls.enabled = false;
          this.sendEvent("api", "failure", "get-polls-for-config");
        });
    },
    getMessages: function () {
      MessagesAPI.getMessages()
        .then((resp) => {
          this.messages.count = resp.data.count;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when fetching your messages configuration, PLEASE REFRESH!";
          this.error = true;
          this.sendEvent("api", "failure", "get-messages-for-config");
        });
    },
    resetMessages: function () {
      MessagesAPI.resetMessages()
        .then((resp) => {
          this.messages.count = resp.data.count;
        })
        .catch((error) => {
          this.errorMsg =
            "Oops! Server error when resetting your messages counter!";
          this.error = true;
          this.sendEvent("api", "failure", "reset-messages-counter");
        });
    },
    saveConfig: function () {
      this.errorMsg = "";
      this.error = false;
      this.success = false;
      this.loading = true;

      switch (true) {
        case !this.targetState:
          if (!this.followersCardVisible) {
            this.$root.$emit("bv::toggle::collapse", "follower-card");
          }
          this.$refs.followersCountInput.$el.focus();
          this.errorMsg =
            "Oops! You have incorrectly set your followers TARGET!";
          this.error = true;
          this.loading = false;

          this.sendEvent(
            "configuration",
            "failure",
            "invalid-user-form-input-followers-target"
          );
          return;
        case !this.messageState:
          if (!this.followersCardVisible) {
            this.$root.$emit("bv::toggle::collapse", "follower-card");
          }
          this.$refs.followersMessageInput.$el.focus();
          this.errorMsg =
            "Oops! You have incorrectly set your MESSAGE to followers";
          this.error = true;
          this.loading = false;

          this.sendEvent(
            "configuration",
            "failure",
            "invalid-user-form-input-followers-message"
          );
          return;
        default:
          break;
      }

      if (this.messages.enabled) {
        switch (true) {
          case !this.msgTargetState:
            if (!this.msgCardVisible) {
              this.$root.$emit("bv::toggle::collapse", "messages-card");
            }
            this.$refs.msgTargetRange.$el.focus();
            this.errorMsg =
              "Oops! You have incorrectly set your messages TARGET!";
            this.error = true;
            this.loading = false;

            this.sendEvent(
              "configuration",
              "failure",
              "invalid-user-form-input-msg-target"
            );
            return;
          default:
            break;
        }
      }

      if (this.custom.enabled) {
        switch (true) {
          case !this.customTitleState:
            if (!this.customCardVisible) {
              this.$root.$emit("bv::toggle::collapse", "custom-card");
            }
            this.$refs.msgTargetRange.$el.focus();
            this.errorMsg = "Oops! You have incorrectly set your custom TITLE!";
            this.error = true;
            this.loading = false;

            this.sendEvent(
              "configuration",
              "failure",
              "invalid-user-form-input-custom-title"
            );
            return;
          case !this.customImgState:
            if (!this.customCardVisible) {
              this.$root.$emit("bv::toggle::collapse", "custom-card");
            }
            this.$refs.msgTargetRange.$el.focus();
            this.errorMsg =
              "Oops! You have incorrectly set your custom image URL, must be shorter than 200!";
            this.error = true;
            this.loading = false;

            this.sendEvent(
              "configuration",
              "failure",
              "invalid-user-form-input-custom-img"
            );
            return;
          default:
            break;
        }
      }

      if (this.subscribers.enabled) {
        switch (true) {
          case !this.subsTargetState:
            if (!this.subsCardVisible) {
              this.$root.$emit("bv::toggle::collapse", "subscribers-card");
            }
            this.$refs.subsTargetRange.$el.focus();
            this.errorMsg =
              "Oops! You have incorrectly set your subscribers TARGET!";
            this.error = true;
            this.loading = false;

            this.sendEvent(
              "configuration",
              "failure",
              "invalid-user-form-input-subs-target"
            );
            return;
          default:
            break;
        }
      }

      if (this.motd) {
        switch (true) {
          case !this.motdTargetState:
            if (!this.motdCardVisible) {
              this.$root.$emit("bv::toggle::collapse", "motd-card");
            }
            this.$refs.motdMsgInput.$el.focus();
            this.errorMsg =
              "Oops! You have incorrectly set your Message Of The Day!";
            this.error = true;
            this.loading = false;

            this.sendEvent(
              "configuration",
              "failure",
              "invalid-user-form-input-motd-msg"
            );
            return;
          default:
            break;
        }
      }

      ConfigAPI.saveConfig(
        {
          pBkgColour: this.panelBkgColour,
          pFontColour: this.panelFontColour,
          fTarget: this.target,
          fGaugeColour: this.followersGaugeColour,
          fMessage: this.message,
          fDisplay: this.displayRecentFollowers,
          fDarkMode: this.darkMode,
        },
        this.messages,
        this.subscribers,
        this.misc,
        this.motd,
        this.hypetrain,
        this.custom,
        this.goals,
        this.charity
      )
        .then((data) => {
          this.success = true;
          this.successMsg = "Configuration updated!";
          this.sendEvent("api", "success", "save-configuration-success");
        })
        .catch((error) => {
          this.errorMsg = "Oops! Server error when saving your configuration!";
          this.error = true;
          this.sendEvent("api", "failure", "save-configuration-failure");
        })
        .finally(() => {
          this.loading = false;
        });
      return;
    },
    streamlabsAuth: function () {
      StreamlabsAPI.getAuth()
        .then((resp) => {
          if (resp.data.error) {
            if (resp.data.error == "Missing user access token") {
              this.messages.streamlabs = false;
              return;
            }
          }
          this.messages.streamlabs = true;
        })
        .catch((error) => {
          this.messages.streamlabs = false;
          this.sendEvent("api", "failure", "streamlabs-auth");
        });
      return;
    },
    streamlabsTest: function () {
      this.errorMsg = "";
      this.error = false;
      this.success = false;
      this.loading = true;

      StreamlabsAPI.testAlert()
        .then((resp) => {
          if (resp.data.error) {
            if (resp.data.error == "Missing user access token") {
              this.loading = false;
              this.errorMsg = "Oops! Streamlabs auth failed!";
              this.error = true;
              this.messages.streamlabs = false;
              return;
            }
          }
          this.success = true;
          this.successMsg = "Streamlabs - Test alert sent!";
        })
        .catch((error) => {
          this.messages.streamlabs = false;
          this.loading = false;
          this.errorMsg = "Oops! Streamlabs test alert failed!!";
          this.error = true;
          this.sendEvent("api", "failure", "streamlabs-alert-test");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addEmoji: function (emoji) {
      this.message += emoji.native;
      this.emojiShow = false;
    },
    formatNumber: function (value) {
      if (isNaN(parseInt(value.replace(/,/g, ""), 10))) {
        return value;
      }

      return parseInt(value.replace(/,/g, ""), 10).toLocaleString();
    },
    cardVisibility: function (collapseId, visible) {
      switch (collapseId) {
        case "follower-card":
          this.followersCardVisible = visible;
          break;
        case "messages-card":
          this.msgCardVisible = visible;
          break;
        case "subscribers-card":
          this.subsCardVisible = visible;
          break;
        case "motd-card":
          this.motdCardVisible = visible;
          break;
        case "custom-card":
          this.customCardVisible = visible;
        case "goals-card":
          this.goalsCardVisible = visible;
          break;
        case "charity-card":
          this.charityCardVisible = visible;
          break;
      }
    },
    bitsSupported: function () {
      if (this.bitsEnabled()) {
        this.messages.feature = false;
        return;
      }
      this.messages.feature = !this.messages.feature;
    },
    hypetrainSupported: function () {
      if (this.hypetrain.feature) {
        this.hypetrain.popover = false;
        return;
      }
      this.hypetrain.popover = !this.hypetrain.popover;
    },
    authorizePermissions: function () {
      const { apiId } = this.$store.state;

      var config = ConfigAPI.getGlobalConfig();

      var scopes = "user:read:email+bits:read+user:read:broadcast+chat:read+channel:read:subscriptions+moderation:read+channel:read:redemptions+channel:read:hype_train+channel:read:redemptions+user:read:blocked_users+user:read:subscriptions+channel:read:polls+channel:read:predictions+channel:read:goals+moderator:manage:announcements+channel:read:vips+channel:read:charity+user:edit:broadcast"
      if (config.scopes) {
        scopes = config.scopes.join("+")
      }

      window.open(
        "https://id.twitch.tv/oauth2/authorize?" +
          "response_type=code" +
          "&client_id=e93cf8730nd11z7gepkly2gry5kv8k" +
          "&redirect_uri=https://" +
          apiId +
          ".execute-api.us-east-1.amazonaws.com/Prod/twitch-auth" +
          "&scope=" + scopes +
          //"&scope=analytics:read:extensions+user:edit+user:read:email+clips:edit+bits:read+analytics:read:games+user:edit:broadcast+user:read:broadcast+chat:read+chat:edit+channel:moderate+channel:read:subscriptions+whispers:read+whispers:edit+moderation:read+channel:read:redemptions+channel:edit:commercial+channel:read:hype_train+channel:read:stream_key+channel:manage:extensions+channel:manage:broadcast+user:edit:follows+channel:manage:redemptions+channel:read:editors+channel:manage:videos+user:read:blocked_users+user:manage:blocked_users+user:read:subscriptions+user:read:follows+channel:manage:polls+channel:manage:predictions+channel:read:polls+channel:read:predictions+moderator:manage:automod+channel:manage:schedule+channel:read:goals+moderator:read:automod_settings+moderator:manage:automod_settings+moderator:manage:banned_users+moderator:read:blocked_terms+moderator:manage:blocked_terms+moderator:read:chat_settings+moderator:manage:chat_settings+channel:manage:raids+moderator:manage:announcements+moderator:manage:chat_messages+user:manage:chat_color+channel:manage:moderators+channel:read:vips+channel:manage:vips+user:manage:whispers+channel:read:charity" +
          "+openid" +
          '&claims={"id_token":{"email":null,"email_verified":null},"userinfo":{"email": null, "preferred_username":null,"picture":null,"updated_at":null}}',
        "_blank"
      );
    },
    accessGranted: function () {
      this.getSubscribers();
      this.getHypeTrain();
      this.getGoals();
      this.getCharities();
    },
    authorizeStreamlabs: function () {
      window.open(
        "https://www.streamlabs.com/api/v1.0/authorize?" +
          "client_id=B5MWFeJU0GYYVMcXRVg8u8Dnq34rg1xyVY64FW0Z" +
          "&redirect_uri=https://0u3uqckeqf.execute-api.us-east-1.amazonaws.com/Prod/streamlabs-auth" +
          "&response_type=code" +
          "&scope=alerts.write+alerts.create",
        "_blank"
      );
    },
    customEnabledHandler: function (obj) {
      if (!obj.value) {
        this.misc.view = "followers";

        var item = {
          value: "custom",
          text: this.custom.title,
        };

        const index = this.misc.views
          .map(function (e) {
            return e.value;
          })
          .indexOf("custom");

        if (index > -1) {
          this.misc.views.splice(index, 1);
        }

        return;
      }

      var item = {
        value: "custom",
        text: this.custom.title,
      };
      this.misc.views.push(item);
    },
    getBoasts: function () {
      BoastsAPI.getBoasts()
        .then((resp) => {
          this.boasts.list = resp.data;
          setTimeout(
            function () {
              this.boasts.loading = false;
            }.bind(this),
            3000
          );

          if (this.boasts.list.length == 0) {
            return;
          }

          this.boasts.busy = false;
        })
        .catch((error) => {
          this.sendEvent("api", "failure", "get-Boasts");
        });
    },
    getDiscordWidget: function () {
      DiscordAPI.getDiscordWidget()
        .then((resp) => {
          this.discordLink = resp.data.instant_invite;
        })
        .catch((error) => {
          this.sendEvent("api", "failure", "get-discord-widget");
        });
    },
    deleteBoast: function (arry, data) {
      this.error = false;
      this.success = false;
      this.loading = true;
      this.errMsg = "";
      this.successMsg = "";

      BoastsAPI.deleteBoast(arry[data.index].key)
        .then((resp) => {
          this.loading = false;
          this.success = true;

          this.successMsg = "Deleted message by " + arry[data.index].username;
          arry.splice([data.index], 1);
        })
        .catch((error) => {
          this.loading = false;

          this.sendEvent("api", "failure", "delete-boast");
          this.error = true;
          this.errorMsg =
            "Failed to delete message by " + arry[data.index].username;
        });
    },
  },
  computed: {
    targetState() {
      if (isNaN(parseInt(this.target))) {
        return false;
      }

      var target = parseInt(this.target.replace(/,/g, ""), 10);
      return target > this.followers;
    },
    messageState() {
      return this.message.length <= 50;
    },
    msgTargetState() {
      if (isNaN(parseInt(this.messages.target))) {
        return false;
      }

      var target = parseInt(this.messages.target.replace(/,/g, ""), 10);
      return target > this.messages.count;
    },
    subsTargetState() {
      if (isNaN(parseInt(this.subscribers.target))) {
        return false;
      }

      var target = parseInt(this.subscribers.target.replace(/,/g, ""), 10);
      return target > this.subscribers.count;
    },
    motdTargetState() {
      return this.motd.msg.length <= 50;
    },
    motdTargetState() {
      return this.motd.msg.length <= 50;
    },
    customTitleState() {
      return this.custom.title.length <= 20 && this.custom.title.length > 0;
    },
    customImgState() {
      return this.custom.img.length <= 200 && this.custom.title.length >= 0;
    },
    msgResetDisabled() {
      if (this.messages.count == 0) {
        return true;
      }
      return false;
    },
    viewsValidation() {
      if (this.misc.views.length == 1) {
        return true;
      }
      return false;
    },
    customEnabledTHandler: function (value, source) {
      if (!value) {
        this.misc.view = "followers";
      }
    },
    pollsChange: function () {},
    style() {
      return {};
    },
  },
  watch: {
    "subscribers.enabled": function (enabled) {
      if (enabled) {
        this.misc.views.push({ value: "subscribers", text: "Subscribers" });
      }
    },
    "goals.enabled": function (enabled) {
      if (enabled) {
        this.misc.views.push({ value: "goals", text: "Twitch Goal" });
      }
    },
    "charity.enabled": function (enabled) {
      if (enabled) {
        this.misc.views.push({ value: "charity", text: "Twitch Charity" });
      }
    },
    "boasts.list.length": function (i) {
      if (i == 0) {
        this.boasts.busy = true;
      }
    },
    "darkMode": function (darkMode) {
      if (darkMode) {
        this.appBkgColour = "#183153";
        this.appFontColour = "white";
        return
      }
      this.appBkgColour = "white";
      this.appFontColour = "black"
    },
  },
  components: {
    ExtHeader,
    Picker,
    ColorPicker,
  },
};
</script>

<style scoped>
.btn-secondary {
  background-color: v-bind(panelBkgColour);
  color: v-bind(panelFontColour);
}

.my-control.form-control {
  opacity: 0;
}

body {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

div {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

#colourPos {
  margin-left: 20px;
  margin-top: 5px;
}

.table {
    color: v-bind(appFontColour);
}
</style>

<style lang="scss">
body {
  background-color: v-bind(appBkgColour);
  color: v-bind(appFontColour);
}

.table {
    color: v-bind(appFontColour);
}
</style>
